import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ca6acc6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7ca6acc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca6acc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca6acc6')) {
      api.createRecord('7ca6acc6', component.options)
    } else {
      api.reload('7ca6acc6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7ca6acc6&scoped=true", function () {
      api.rerender('7ca6acc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/documents/index.vue"
export default component.exports